var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isBasicInfoLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isBasicInfoLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [(_vm.paymentpending) ? _c('p', {
    staticClass: "-btn btn-danger",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "title": "Payment Pending"
    }
  }, [_vm._v("\n            Payment is pending for this shipment ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All",
      "disabled": _vm.subtabdisabledflag
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n        Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All",
      "disabled": _vm.subtabdisabledflag
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n        Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Serviceability",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Serviceability")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "serviceabilityform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Truck Load Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TruckLoadType),
      expression: "TruckLoadType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "PTL",
      "value": "PTL",
      "name": "TruckLoadType",
      "disabled": _vm.editServicabilityflag
    },
    domProps: {
      "checked": _vm._q(_vm.TruckLoadType, "PTL")
    },
    on: {
      "change": _vm.ClearCheckServicabilityFlag,
      "__c": function($event) {
        _vm.TruckLoadType = "PTL"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "PTL"
    }
  }, [_vm._v("PTL")]), _vm._v("     \n                    ")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.TruckLoadType')),
      expression: "errors.has('serviceabilityform.TruckLoadType')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Truck Load Type field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Route Mode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Surface",
      "value": "Surface",
      "name": "RouteMode",
      "disabled": _vm.editServicabilityflag
    },
    domProps: {
      "checked": _vm._q(_vm.RouteMode, "Surface")
    },
    on: {
      "change": _vm.ClearCheckServicabilityFlag,
      "__c": function($event) {
        _vm.RouteMode = "Surface"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Surface"
    }
  }, [_vm._v("Surface ")]), _vm._v("     \n                    ")]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Air",
      "value": "Air",
      "name": "RouteMode",
      "disabled": _vm.editServicabilityflag
    },
    domProps: {
      "checked": _vm._q(_vm.RouteMode, "Air")
    },
    on: {
      "change": _vm.ClearCheckServicabilityFlag,
      "__c": function($event) {
        _vm.RouteMode = "Air"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Air"
    }
  }, [_vm._v("Air")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.RouteMode')),
      expression: "errors.has('serviceabilityform.RouteMode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Route Mode field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Booking Mode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BookingMode),
      expression: "BookingMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Credit",
      "value": "Credit",
      "name": "BookingMode",
      "disabled": _vm.editServicabilityflag
    },
    domProps: {
      "checked": _vm._q(_vm.BookingMode, "Credit")
    },
    on: {
      "change": _vm.ClearCheckServicabilityFlag,
      "__c": function($event) {
        _vm.BookingMode = "Credit"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Credit"
    }
  }, [_vm._v("Credit ")]), _vm._v("                \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BookingMode),
      expression: "BookingMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Prepaid",
      "value": "PrePaid",
      "name": "BookingMode",
      "disabled": _vm.editServicabilityflag
    },
    domProps: {
      "checked": _vm._q(_vm.BookingMode, "PrePaid")
    },
    on: {
      "change": _vm.ClearCheckServicabilityFlag,
      "__c": function($event) {
        _vm.BookingMode = "PrePaid"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Prepaid"
    }
  }, [_vm._v("Prepaid")]), _vm._v("     \n                    ")]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BookingMode),
      expression: "BookingMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "ToPay",
      "value": "To Pay",
      "name": "BookingMode",
      "disabled": _vm.editServicabilityflag
    },
    domProps: {
      "checked": _vm._q(_vm.BookingMode, "To Pay")
    },
    on: {
      "change": _vm.ClearCheckServicabilityFlag,
      "__c": function($event) {
        _vm.BookingMode = "To Pay"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "ToPay"
    }
  }, [_vm._v("FTC")]), _vm._v("                   \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BookingMode),
      expression: "BookingMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Cash",
      "value": "Cash",
      "name": "BookingMode",
      "disabled": true
    },
    domProps: {
      "checked": _vm._q(_vm.BookingMode, "Cash")
    },
    on: {
      "change": _vm.ClearCheckServicabilityFlag,
      "__c": function($event) {
        _vm.BookingMode = "Cash"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "opacity": "0.5"
    },
    attrs: {
      "for": "Cash"
    }
  }, [_vm._v("Cash")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.BookingMode')),
      expression: "errors.has('serviceabilityform.BookingMode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Booking Mode field is required")])], 1)]), _vm._v(" "), (_vm.BookingMode == 'PrePaid' && _vm.RouteMode == 'Air') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Business Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "max-heighFt": 150,
      "options": _vm.airCargoOptions.resultbusinesstype,
      "name": "businesstype",
      "placeholder": "Business Type",
      "disabled": _vm.businesstypedisabled || _vm.editServicabilityflag,
      "id": "origin",
      "label": "businesstype",
      "select-label": '',
      "track-by": "businesstype",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "open-direction": "bottom"
    },
    model: {
      value: (_vm.businesstype),
      callback: function($$v) {
        _vm.businesstype = $$v
      },
      expression: "businesstype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.businesstype')),
      expression: "errors.has('serviceabilityform.businesstype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select business type")])], 1), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Airline")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "max-height": 150,
      "options": _vm.airCargoOptions.resultairlinename,
      "name": "airlinename",
      "placeholder": "Airline",
      "disabled": _vm.editServicabilityflag,
      "id": "origin",
      "label": "airlinename",
      "select-label": '',
      "track-by": "airlinename",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "open-direction": "bottom"
    },
    model: {
      value: (_vm.airlinename),
      callback: function($$v) {
        _vm.airlinename = $$v
      },
      expression: "airlinename"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.airlinename')),
      expression: "errors.has('serviceabilityform.airlinename')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select airline")])], 1), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Product Type ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "max-height": 150,
      "options": _vm.airCargoOptions.resultproducttype,
      "name": "producttype",
      "placeholder": "Product Type",
      "disabled": _vm.editServicabilityflag,
      "id": "origin",
      "label": "producttype",
      "select-label": '',
      "track-by": "producttype",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "open-direction": "bottom"
    },
    model: {
      value: (_vm.producttype),
      callback: function($$v) {
        _vm.producttype = $$v
      },
      expression: "producttype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.producttype')),
      expression: "errors.has('serviceabilityform.producttype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select product type")])], 1), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Flight Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "max-height": 150,
      "options": _vm.airCargoOptions.resultflighttype,
      "name": "flighttype",
      "placeholder": "Flight Type",
      "disabled": _vm.editServicabilityflag,
      "id": "origin",
      "label": "flighttype",
      "select-label": '',
      "track-by": "flighttype",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "open-direction": "bottom"
    },
    model: {
      value: (_vm.flighttype),
      callback: function($$v) {
        _vm.flighttype = $$v
      },
      expression: "flighttype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.flighttype')),
      expression: "errors.has('serviceabilityform.flighttype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select flight type")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("PickUp PinCode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thumb-tack' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PickupPincode),
      expression: "PickupPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "PickupPincode",
      "id": "PickupPincode",
      "placeholder": "Enter Pickup Pincode",
      "pattern": "^(\\d{6})$",
      "maxlength": 6,
      "disabled": _vm.editServicabilityflag
    },
    domProps: {
      "value": (_vm.PickupPincode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.PickupPincode = $event.target.value
      }, _vm.clearPickupServicableflag]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.PickupPincode')),
      expression: "errors.has('serviceabilityform.PickupPincode')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("The PickUp PinCode field is required")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PickupPincodeServicable == 1),
      expression: "PickupPincodeServicable==1"
    }],
    staticClass: "text-success successmsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Serviceable")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PickupPincodeServicable == 0),
      expression: "PickupPincodeServicable==0"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.sourcepincodeerrmsg))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Destination PinCode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thumb-tack' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DestinationPincode),
      expression: "DestinationPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "DestinationPincode",
      "id": "DestinationPincode",
      "placeholder": "Enter Destination Pincode",
      "pattern": "^(\\d{6})$",
      "maxlength": 6,
      "disabled": _vm.editServicabilityflag
    },
    domProps: {
      "value": (_vm.DestinationPincode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.DestinationPincode = $event.target.value
      }, _vm.clearDestinationServicableflag]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.DestinationPincode')),
      expression: "errors.has('serviceabilityform.DestinationPincode')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("The Destination PinCode field is required")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.DestinationPincodeServicable == 1),
      expression: "DestinationPincodeServicable==1"
    }],
    staticClass: "text-success successmsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Serviceable")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.DestinationPincodeServicable == 0),
      expression: "DestinationPincodeServicable==0"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.destinationpincodeerrmsg))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBasicDetailsflag == false),
      expression: "editBasicDetailsflag==false"
    }],
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800"
    },
    attrs: {
      "type": "button",
      "title": "Check Serviceability",
      "disabled": (_vm.pincodeservicabilitycheckflag)
    },
    on: {
      "click": _vm.checkPincodeServicability
    }
  }, [_vm._v("Check Serviceability "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pincodeservicabilitycheckflag == true),
      expression: "pincodeservicabilitycheckflag == true"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v("  \n                    "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBasicDetailsflag == false),
      expression: "editBasicDetailsflag==false"
    }],
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button",
      "title": "Reset",
      "disabled": _vm.editServicabilityflag
    },
    on: {
      "click": _vm.resetPincode
    }
  }, [_vm._v("Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Origin Hub")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OriginHub),
      expression: "OriginHub"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "OriginHub",
      "id": "OriginHub",
      "placeholder": "Enter Origin Hub",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.OriginHub)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.OriginHub = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.OriginHub')),
      expression: "errors.has('serviceabilityform.OriginHub')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Origin Hub field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Destination Hub")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-plane' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DestinationHub),
      expression: "DestinationHub"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "DestinationHub",
      "id": "DestinationHub",
      "placeholder": "Enter Destination Hub",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.DestinationHub)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.preventDefault();
        _vm.processTags($event.target.value)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab(1)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.DestinationHub = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('serviceabilityform.DestinationHub')),
      expression: "errors.has('serviceabilityform.DestinationHub')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Destination Hub field is required")])], 1), _vm._v(" "), _c('div', {
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.preventDefault();
        _vm.processTags($event.target.value)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab(1)
      }]
    }
  }, [_c('b-input-group', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBasicDetailsflag == false),
      expression: "editBasicDetailsflag==false"
    }],
    staticClass: "-btn btn-success",
    staticStyle: {
      "margin-left": "18px",
      "margin-top": "29px"
    },
    attrs: {
      "type": "button",
      "title": "Save",
      "disabled": !_vm.pincodeservicabilitycheckflag
    },
    on: {
      "click": _vm.checkServiceabilityValidation
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "PickupLocation",
      "id": "chck2",
      "disabled": _vm.subtabdisabledflag
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "pickuplocationform"
    }
  }, [_c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentDropByClient),
      expression: "ShipmentDropByClient"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ShipmentDropByClient",
      "name": "ShipmentDropByClient",
      "disabled": _vm.editBasicDetailsflag || _vm.disableShipmentDropByClient
    },
    domProps: {
      "checked": Array.isArray(_vm.ShipmentDropByClient) ? _vm._i(_vm.ShipmentDropByClient, "1") > -1 : (_vm.ShipmentDropByClient)
    },
    on: {
      "click": _vm.ChkDropByClient,
      "__c": function($event) {
        var $$a = _vm.ShipmentDropByClient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ShipmentDropByClient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ShipmentDropByClient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ShipmentDropByClient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("Shipment drop to hub by client   "), _c('span', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.checkhover
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "title": "This shipment has to be dropped at origin branch by consignor"
    }
  })])]), _c('tooltip', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "tooltip"
    }
  }, [_vm._v("\n                    This shipment has to be dropped at origin branch by consignor\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("PinCode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thumb-tack' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PinCode),
      expression: "PinCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "PinCode",
      "id": "PinCode",
      "placeholder": "Enter Pincode",
      "pattern": "^(\\d{6})$",
      "maxlength": 6,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.PinCode)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PinCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.PinCode')),
      expression: "errors.has('pickuplocationform.PinCode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.PinCode')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("City")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.City),
      expression: "City"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "City",
      "id": "City",
      "placeholder": "Enter City",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.City = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.City')),
      expression: "errors.has('pickuplocationform.City')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.City')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("State")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.State),
      expression: "State"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "State",
      "id": "State",
      "placeholder": "Enter State",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.State)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.State = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.State')),
      expression: "errors.has('pickuplocationform.State')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.State')))])], 1), _vm._v(" "), (_vm.ShipmentDropByClient == false) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBasicDetailsflag == false || _vm.editPickupLocation == false),
      expression: "editBasicDetailsflag==false || editPickupLocation==false"
    }],
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Add New Location",
      "disabled": _vm.editBasicDetailsflag && _vm.editPickupLocation
    },
    on: {
      "click": _vm.addNewLocation
    }
  }, [_vm._v("Add New Location "), _c('i', {
    staticClass: "fa fa-map-marker"
  })])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.ShipmentDropByClient == false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AddNewLocationFlag == false),
      expression: "AddNewLocationFlag==false"
    }],
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Location")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.AddNewLocationFlag == false ? 'required' : ''))),
      expression: "`${AddNewLocationFlag == false ? 'required' : ''}`"
    }],
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.Locationlist,
      "placeholder": "Select Location",
      "append-to-body": true,
      "valueFormat": "object",
      "name": "Location",
      "disabled": _vm.editBasicDetailsflag && _vm.editPickupLocation
    },
    on: {
      "input": _vm.selectedLocation
    },
    model: {
      value: (_vm.Location),
      callback: function($$v) {
        _vm.Location = $$v
      },
      expression: "Location"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Location')),
      expression: "errors.has('pickuplocationform.Location')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Location field is required")])], 1) : _vm._e(), _vm._v(" "), (_vm.ShipmentDropByClient == false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AddNewLocationFlag == true),
      expression: "AddNewLocationFlag==true"
    }],
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Location Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LocationName),
      expression: "LocationName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.AddNewLocationFlag == true ? 'required' : ''))),
      expression: "`${AddNewLocationFlag == true ? 'required' : ''}`"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "LocationName",
      "id": "LocationName",
      "placeholder": "Enter Location Name",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.LocationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.LocationName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.LocationName')),
      expression: "errors.has('pickuplocationform.LocationName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Location Name field is required")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Mobile),
      expression: "Mobile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:10'),
      expression: "'required|numeric|digits:10'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Mobile",
      "id": "Mobile",
      "placeholder": "Enter Mobile Number",
      "maxlength": "10",
      "pattern": "^[6789](\\d)(?!\\1+$){3,}\\d{8}$",
      "disabled": (_vm.AddNewLocationFlag == false && _vm.ShipmentDropByClient == false && _vm.editGSTNo == false)
    },
    domProps: {
      "value": (_vm.Mobile)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Mobile')),
      expression: "errors.has('pickuplocationform.Mobile')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Mobile')))]), _vm._v(" "), (_vm.errors.first('pickuplocationform.Mobile') == 'The Mobile field format is invalid') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("Number Should Start with 6,7,8 or 9")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Telephone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Telephone),
      expression: "Telephone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Telephone",
      "id": "Telephone",
      "placeholder": "Enter Telephone",
      "maxlength": "12",
      "minlength": "6",
      "disabled": (_vm.AddNewLocationFlag == false && _vm.ShipmentDropByClient == false && _vm.editGSTNo == false)
    },
    domProps: {
      "value": (_vm.Telephone)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Telephone')),
      expression: "errors.has('pickuplocationform.Telephone')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Telephone')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Email")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Email),
      expression: "Email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Enter Email",
      "maxlength": "100",
      "disabled": (_vm.AddNewLocationFlag == false && _vm.ShipmentDropByClient == false && _vm.editGSTNo == false)
    },
    domProps: {
      "value": (_vm.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Email')),
      expression: "errors.has('pickuplocationform.Email')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Email')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.ShipmentDropByClient == false) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Address),
      expression: "Address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "Address",
      "name": "Address",
      "placeholder": "Address ",
      "maxlength": "255",
      "disabled": _vm.AddNewLocationFlag == false && _vm.editGSTNo == false
    },
    domProps: {
      "value": (_vm.Address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Address')),
      expression: "errors.has('pickuplocationform.Address')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Address')))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      }
    }
  }, [_vm._v("GST No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GstNo),
      expression: "GstNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validate_gst'),
      expression: "'required|validate_gst'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Gst No",
      "id": "GstNo",
      "placeholder": "Enter GST NO. ",
      "disabled": (_vm.AddNewLocationFlag == false && _vm.ShipmentDropByClient == false && _vm.editGSTNo == false)
    },
    domProps: {
      "value": (_vm.GstNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GstNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "gstBlock"
    }
  }, [_vm._v("Note: Allowed GST Format 00XXXXX0000X1ZZ.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Gst No')),
      expression: "errors.has('pickuplocationform.Gst No')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Gst No')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBasicDetailsflag == false),
      expression: "editBasicDetailsflag==false"
    }],
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save And Next",
      "disabled": _vm.editBasicDetailsflag || _vm.subtabdisabledflag
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      },
      "click": _vm.checkPickupLocationValidation
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editPickupLocation == false),
      expression: "editPickupLocation==false"
    }],
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save",
      "disabled": (_vm.editBasicDetailsflag && _vm.editPickupLocation) || _vm.subtabdisabledflag
    },
    on: {
      "click": _vm.checkPickupLocationValidation
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ShipmentDetails",
      "id": "chck3",
      "disabled": _vm.subtabdisabledflag
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "shipmentdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Number of invoices")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list-ol' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NumberOfInvoice),
      expression: "NumberOfInvoice"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "NumberOfInvoice",
      "id": "NumberOfInvoice",
      "placeholder": "Enter Number Of Invoice",
      "disabled": _vm.editBasicDetailsflag,
      "maxlength": 2
    },
    domProps: {
      "value": (_vm.NumberOfInvoice)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.NumberOfInvoice = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.NumberOfInvoice')),
      expression: "errors.has('shipmentdetailsform.NumberOfInvoice')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Number Of Invoices field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Total Shipment Declared Value (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-inr' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TotalShipmentValue),
      expression: "TotalShipmentValue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "title": "Total Shipment Declared Value (INR)",
      "name": "Total Shipment Declared Value",
      "id": "TotalShipmentValue",
      "placeholder": "Enter Total Shipment Value",
      "min": 1,
      "disabled": _vm.editBasicDetailsflag && _vm.editShipmentValue
    },
    domProps: {
      "value": (_vm.TotalShipmentValue)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TotalShipmentValue = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('shipmentdetailsform.Total Shipment Declared Value') == 'The Total Shipment Declared Value field must be numeric and may contain decimal points') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Total Shipment Declared Value field is required ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('shipmentdetailsform.Total Shipment Declared Value') && _vm.errors.first('shipmentdetailsform.Total Shipment Declared Value') != 'The Total Shipment Declared Value field must be numeric and may contain decimal points') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('shipmentdetailsform.Total Shipment Declared Value')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Requested PickUp Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RequestedPickupDate),
      expression: "RequestedPickupDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "deliverydate",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "tabindex": "-1",
      "name": "RequestedPickupDate",
      "onkeydown": "return false",
      "min": _vm.todaysDate,
      "disabled": _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.RequestedPickupDate)
    },
    on: {
      "change": _vm.ValidateTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RequestedPickupDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.RequestedPickupDate')),
      expression: "errors.has('shipmentdetailsform.RequestedPickupDate')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Requested PickUp Date field is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Number of MPS")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list-ol' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NumberOfMPS),
      expression: "NumberOfMPS"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "NumberOfMPS",
      "id": "NumberOfMPS",
      "placeholder": "Enter Number Of MPS",
      "disabled": _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.NumberOfMPS)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.NumberOfMPS = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.NumberOfMPS')),
      expression: "errors.has('shipmentdetailsform.NumberOfMPS')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Number Of MPS field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Total Shipment Declared Weight (Kg)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TotalShipmentWeight),
      expression: "TotalShipmentWeight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "title": "Total Shipment Declared Weight (Kg)",
      "name": "Total Shipment Declared Weight",
      "id": "TotalShipmentWeight",
      "placeholder": "Enter Total Shipment Weight",
      "min": 0.00001,
      "disabled": _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.TotalShipmentWeight)
    },
    on: {
      "click": _vm.removeWeightError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TotalShipmentWeight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.Total Shipment Declared Weight')),
      expression: "errors.has('shipmentdetailsform.Total Shipment Declared Weight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Total Shipment Declared Weight field is required ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Requested PickUp Time (hrs)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticClass: "width"
  }, [_c('label', [_vm._v("From :")]), _vm._v("  \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RequestedPickupTimeFrom),
      expression: "RequestedPickupTimeFrom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "id": "RequestedPickupTimeFrom",
      "name": "RequestedPickupTimeFrom",
      "disabled": true
    },
    domProps: {
      "value": (_vm.RequestedPickupTimeFrom)
    },
    on: {
      "change": _vm.ValidateTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RequestedPickupTimeFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.RequestedPickupTimeFrom')),
      expression: "errors.has('shipmentdetailsform.RequestedPickupTimeFrom')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Requested PickUp From Time field is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticClass: "width"
  }, [_vm._v("\n                      "), _c('label', [_vm._v("To :")]), _vm._v("  \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RequestedPickupTimeTo),
      expression: "RequestedPickupTimeTo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "time",
      "id": "RequestedPickupTimeTo",
      "name": "RequestedPickupTimeTo",
      "disabled": true
    },
    domProps: {
      "value": (_vm.RequestedPickupTimeTo)
    },
    on: {
      "change": _vm.ValidateTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RequestedPickupTimeTo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.RequestedPickupTimeTo')),
      expression: "errors.has('shipmentdetailsform.RequestedPickupTimeTo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Requested PickUp To Time field is required.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "200px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("S.N.")]), _vm._v(" "), (_vm.boxTypeshow) ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "15%"
    }
  }, [_vm._v("Product")]) : _vm._e(), _vm._v(" "), (_vm.boxTypeshow) ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "15%"
    }
  }, [_vm._v("Box Type")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "3",
      "width": "50%"
    }
  }, [_vm._v("Box Dimensions (cm)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Avg Volumetric Wt per MPS (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "15%"
    }
  }, [_vm._v("Number of"), _c('br'), _vm._v(" boxes")]), _vm._v(" "), (_vm.editBasicDetailsflag == false) ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('b', [_vm._v("#")])]) : _vm._e()]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Breadth")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Height")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.boxTypeshow) ? _c('td', [_c('b-input-group', [_c('treeselect', {
      attrs: {
        "multiple": false,
        "max-height": 200,
        "clearable": false,
        "options": _vm.clientproductlist,
        "placeholder": "Select Product",
        "append-to-body": true,
        "valueFormat": "object",
        "name": "Location",
        "disabled": _vm.editBasicDetailsflag && _vm.editShipmentDimensions
      },
      on: {
        "input": function($event) {
          _vm.selectedProduct(index)
        }
      },
      model: {
        value: (_vm.selectedproduct[index]),
        callback: function($$v) {
          _vm.$set(_vm.selectedproduct, index, $$v)
        },
        expression: "selectedproduct[index]"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.boxTypeshow) ? _c('td', [_c('b-input-group', [_c('treeselect', {
      attrs: {
        "multiple": false,
        "max-height": 200,
        "clearable": false,
        "options": _vm.clientboxtypelist[index],
        "placeholder": "Select BoxType",
        "append-to-body": true,
        "valueFormat": "object",
        "name": "Location",
        "disabled": (_vm.editBasicDetailsflag && _vm.editShipmentDimensions) || !_vm.isProductSelected[index]
      },
      on: {
        "input": function($event) {
          _vm.selectedBoxType(index)
        }
      },
      model: {
        value: (_vm.selectedboxtype[index]),
        callback: function($$v) {
          _vm.$set(_vm.selectedboxtype, index, $$v)
        },
        expression: "selectedboxtype[index]"
      }
    })], 1), _vm._v(" "), (_vm.otherbox[index]) ? _c('b-input-group', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.otherboxname[index]),
        expression: "form.otherboxname[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "boxtype",
        "name": _vm.setname(index, 'boxtype'),
        "placeholder": "Other Box Type",
        "disabled": _vm.editBasicDetailsflag && _vm.editShipmentDimensions
      },
      domProps: {
        "value": (_vm.form.otherboxname[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.otherboxname, index, $event.target.value)
        }
      }
    })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.boxdimension[index].length),
        expression: "form.boxdimension[index].length"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0.01",
        "id": "length",
        "name": _vm.setname(index, 'length'),
        "placeholder": "Length",
        "disabled": (_vm.editBasicDetailsflag && _vm.editShipmentDimensions) || _vm.editDimensionflag[index]
      },
      domProps: {
        "value": (_vm.form.boxdimension[index].length)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.form.boxdimension[index].length = $event.target.value
        }, function($event) {
          _vm.setVolumetricWt(index)
        }]
      }
    })]), _vm._v(" "), (_vm.errors.has('shipmentdetailsform.length' + index)) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Please enter length")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.boxdimension[index].breadth),
        expression: "form.boxdimension[index].breadth"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0.01",
        "id": "breadth",
        "name": _vm.setname(index, 'breadth'),
        "placeholder": "Breadth",
        "disabled": (_vm.editBasicDetailsflag && _vm.editShipmentDimensions) || _vm.editDimensionflag[index]
      },
      domProps: {
        "value": (_vm.form.boxdimension[index].breadth)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.form.boxdimension[index].breadth = $event.target.value
        }, function($event) {
          _vm.setVolumetricWt(index)
        }]
      }
    })]), _vm._v(" "), (_vm.errors.has('shipmentdetailsform.breadth' + index)) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Please enter breadth")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.boxdimension[index].height),
        expression: "form.boxdimension[index].height"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0.01",
        "id": "height",
        "name": _vm.setname(index, 'height'),
        "placeholder": "Height",
        "disabled": (_vm.editBasicDetailsflag && _vm.editShipmentDimensions) || _vm.editDimensionflag[index]
      },
      domProps: {
        "value": (_vm.form.boxdimension[index].height)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.form.boxdimension[index].height = $event.target.value
        }, function($event) {
          _vm.setVolumetricWt(index)
        }]
      }
    })]), _vm._v(" "), (_vm.errors.has('shipmentdetailsform.height' + index)) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Please enter height")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.form.averagevolumetricweight[index]) + " "), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.averagevolumetricweight[index] > _vm.MaxVolumetricWeight),
        expression: "form.averagevolumetricweight[index] > MaxVolumetricWeight"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Avg Volumetric Wt per MPS must be less than " + _vm._s(_vm.MaxVolumetricWeight) + " Kg")])]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.noofboxes[index]),
        expression: "form.noofboxes[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          min_value: 1
        }),
        expression: "{required: true, min_value:1}"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "1px"
      },
      attrs: {
        "type": "text",
        "min": "0",
        "name": _vm.setname(index, 'noofboxes'),
        "id": _vm.setname(index, 'noofboxes'),
        "placeholder": "No.of Boxes",
        "disabled": _vm.editBasicDetailsflag && _vm.editShipmentDimensions
      },
      domProps: {
        "value": (_vm.form.noofboxes[index])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.noofboxes, index, $event.target.value)
        }, function($event) {
          _vm.checkBoxNo(index)
        }],
        "keypress": function($event) {
          _vm.isIntegerOnlty($event)
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('shipmentdetailsform.noofboxes' + index)),
        expression: "errors.has('shipmentdetailsform.noofboxes'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Please enter no. of boxes")])], 1), _vm._v(" "), (_vm.editBasicDetailsflag == false || _vm.editShipmentDimensions == false) ? _c('td', [((index + 1) < _vm.shipmentData.length) ? _c('i', {
      staticClass: "fa fa-trash fa-2x",
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      attrs: {
        "tabindex": "0",
        "title": "Delete"
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.deleteRow(index)
        },
        "click": function($event) {
          _vm.deleteRow(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), ((index + 1) == _vm.shipmentData.length) ? _c('i', {
      staticClass: "fa fa-plus-circle fa-2x",
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      attrs: {
        "tabindex": "0",
        "title": "Add New"
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.validateShipmentDetails(index)
        },
        "click": function($event) {
          _vm.validateShipmentDetails(index)
        }
      }
    }) : _vm._e()]) : _vm._e()])
  }))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.openConverter
    }
  }, [_vm._v("Convert Inches to Centimeter")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.convertermodal = false
      }
    },
    model: {
      value: (_vm.convertermodal),
      callback: function($$v) {
        _vm.convertermodal = $$v
      },
      expression: "convertermodal"
    }
  }, [_c('b-card', [_c('label', [_c('b', [_vm._v("Enter a value and press Enter")])]), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Convert Inches to Centimeter:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeConverter
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Inches")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inches),
      expression: "inches"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inches",
      "name": "inches",
      "placeholder": "inch"
    },
    domProps: {
      "value": (_vm.inches)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "change": function($event) {
        _vm.inchtocm()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inches = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Centimeters")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cm),
      expression: "cm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cm",
      "name": "cm",
      "placeholder": "cm"
    },
    domProps: {
      "value": (_vm.cm)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "change": function($event) {
        _vm.cmtoinch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cm = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeConverter()
      }
    }
  }, [_vm._v("Close")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBasicDetailsflag == false),
      expression: "editBasicDetailsflag==false"
    }],
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save And Next",
      "disabled": _vm.editBasicDetailsflag
    },
    on: {
      "click": _vm.checkShipmentDetailsValidation
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), (_vm.editShipmentValue == false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save And Next"
    },
    on: {
      "click": _vm.checkShipmentTotalValidation
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.editShipmentDimensions == false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save And Next"
    },
    on: {
      "click": _vm.checkShipmentDimensions
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]) : _vm._e()])])])]), _vm._v(" "), (_vm.subtabdisabledflag == false) ? _c('div', {
    staticStyle: {
      "float": "right",
      "padding-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editBasicDetailsflag == false),
      expression: "editBasicDetailsflag==false"
    }],
    staticClass: "-btn btn-primary1",
    attrs: {
      "type": "button",
      "title": "Save And Next",
      "disabled": _vm.editBasicDetailsflag
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab2(3)
      },
      "click": _vm.saveBasicInformation
    }
  }, [_vm._v("Save And Next  "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15dba662","hasScoped":true}!./src/modules/cargobooking/views/booking/Information/basicinformation/basicinformation.component.html
// module id = 1134
// module chunks = 3